module.exports = __webpack_public_path__ + "img/grayArrow.d4881740.svg";